import Vue from 'vue';

export default {
  state: {
    customerPage: {
      content: '',
    },
  },
  mutations: {
    setCustomerPage(state, data) {
      state.customerPage = data;
    },
  },
  actions: {
    getCustomerPage(store) {
      const path = 'customer';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setCustomerPage', resp.data);
        return resp.data;
      });
    },
  },
};
